import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "react-i18next";
import SwiperCore, {
  Pagination,
  Navigation,
  Keyboard,
  Mousewheel,
} from "swiper";
// import "swiper/components/pagination/pagination.scss";
// import "swiper/components/navigation/navigation.scss";

import styles from "./PropertyCard.module.scss";

import parse from "html-react-parser";
import CustomDateRangePicker from "../../../../components/customDateRangePicker/CustomDateRangePicker";
import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import {
  selectAdults,
  selectChildrensAgesList,
  selectCurrency,
  selectEndDate,
  selectEnvironmentId,
  selectIniDate,
  selectIsTourist,
  selectServerPath,
  selectShowLastRoomMessageInfo,
} from "../../../../redux/slices/enviromentSlice/EnviromentSlice.selectors";
import ImageWrapper from "./components/imageWrapper/ImageWrapper";
import { getMinPrice } from "../../../../utils/getPriceUtils";
import moment from "moment";
import CustomSpinner from "../../../../components/customSpinner/CustomSpinner";
import { useHistory } from "react-router-dom";
import CustomButton from "../../../../components/customButton/CustomButton";
import { useHotelDataContext } from "../../../../hooks/HotelDataContextHook";
import { setEnviroment } from "../../../../redux/slices/enviromentSlice/EnviromentSlice";
import ErrorString from "../../../../components/errorString/ErrorString";
import { Link } from "react-router-dom";
import { ActiveHotelI } from "../mapview/Mapview";
import TitleStars from "./components/titleStars/TitleStars";
import BookingPrice from "./components/bookingPrice/BookingPrice";
import { HotelDataListI } from "../../../../redux/slices/enviromentSlice/EnviromentSlice.type";
import { useLanguage } from "../../../../hooks/languageContextHooks";
import { apiGetCalendarPrice } from "../../../../api/calendarprice/calendarprice";
import useSentryUtils from "../../../../hooks/useSentryUtils";
import UpdateUrlParams from "../../../../hooks/UpdateUrlParams";
import { APP_PAGES } from "../../../../App";
import useScroll from "../../../../hooks/useScroll";
import { FilterSortType, filterStateI } from "../../contexts/filterContext";
import { useWidgetConfigContext } from "src/contexts/widgetConfig/WidgetConfig.context";

SwiperCore.use([Navigation, Pagination, Mousewheel, Keyboard]);

const PropertyCard: React.FC<{
  data: HotelDataListI;
  filterState: filterStateI;
  isColumn?: boolean;
  setActiveHotel?: React.Dispatch<React.SetStateAction<ActiveHotelI>>;
  setIsMiniCardOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  allowAllGuest: boolean;
}> = (props) => {
  // redux hooks
  const iniDate = useAppSelector(selectIniDate);
  const endDate = useAppSelector(selectEndDate);
  const dispatch = useAppDispatch();
  const currency = useAppSelector(selectCurrency);
  const environmentId = useAppSelector(selectEnvironmentId);
  const childrenAges = useAppSelector(selectChildrensAgesList).join(",");
  const adults = useAppSelector(selectAdults);
  const showLastRoomMessageInfo = useAppSelector(selectShowLastRoomMessageInfo);
  const tourist = useAppSelector(selectIsTourist);
  const { language } = useLanguage();

  const { hideRating } = useWidgetConfigContext();

  // custom hooks
  const history = useHistory();
  const { fetchHotelDataList } = useHotelDataContext();
  const { captureError } = useSentryUtils();
  const { updateUrlParams } = UpdateUrlParams();

  const { data, filterState, isColumn, setActiveHotel, setIsMiniCardOpen } =
    props;
  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const [showOverflowText, setShowOverflowText] = useState(false);
  const [showHotelAvailabilityPicker, setShowHotelAvailabilityPicker] =
    useState(false);
  const [getAvailabilityLoading, setGetAvailabilityLoading] = useState(false);
  const [datesAvailable, setDatesAvailable] = useState<{
    [date: string]: boolean;
  }>({});
  const [datesUnavailable, setDatesUnavailable] = useState<{
    [date: string]: boolean;
  }>({});
  const [checkAvailabilityIniDate, setCheckAvailabilityIniDate] = useState("");
  const [checkAvailabilityEndDate, setCheckAvailabilityEndDate] = useState("");
  const [datePickerError, setDatePickerError] = useState("");
  const [focusedInput, setFocusedInput] = useState<
    "startDate" | "endDate" | null
  >();

  const [selectedIniDate, setSelectedIniDate] = useState<moment.Moment | null>(
    null
  );
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    null
  );

  const hotelDescriptionEl = useRef<HTMLDivElement>(null);
  const hotelDescriptionContainer = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();
  const serverPath = useAppSelector(selectServerPath);

  const { scrollToAppTop } = useScroll();

  const handleAvailabilitySearch = async (
    e: React.MouseEvent<HTMLDivElement>
  ) => {
    try {
      scrollToAppTop();
      e.preventDefault();
      if (!selectedEndDate || !selectedIniDate) {
        return setDatePickerError(t("errors.noDaysSelected"));
      }
      dispatch(
        setEnviroment({
          iniDate: selectedIniDate?.format("DD-MM-YYYY"),
          endDate: selectedEndDate?.format("DD-MM-YYYY"),
        })
      );
      let queryArray: { id: string; value: string }[] = [];
      if (history.location.search) {
        queryArray = history.location.search.split("&").map((query) => {
          let currentQuery = query;
          if (query.startsWith("?")) {
            currentQuery = currentQuery.substring(1);
          }
          const a = currentQuery.split("=");
          return { id: a[0], value: a[1] };
        });
      }

      const propertyIdQueryIndex = queryArray.findIndex(
        (query) => query.id === "propertyId"
      );
      const iniDateQueryIndex = queryArray.findIndex(
        (query) => query.id === "iniDate"
      );
      const endDateQueryIndex = queryArray.findIndex(
        (query) => query.id === "endDate"
      );

      if (propertyIdQueryIndex !== -1) {
        queryArray[propertyIdQueryIndex] = {
          id: queryArray[propertyIdQueryIndex].id,
          value: data.id,
        };
      } else {
        queryArray.push({
          id: "propertyId",
          value: data.id,
        });
      }

      if (iniDateQueryIndex !== -1) {
        queryArray[iniDateQueryIndex] = {
          id: queryArray[iniDateQueryIndex].id,
          value: selectedIniDate!.format("DD-MM-YYYY"),
        };
      } else {
        queryArray.push({
          id: "iniDate",
          value: selectedIniDate!.format("DD-MM-YYYY"),
        });
      }
      if (endDateQueryIndex !== -1) {
        queryArray[endDateQueryIndex] = {
          id: queryArray[endDateQueryIndex].id,
          value: selectedEndDate!.format("DD-MM-YYYY"),
        };
      } else {
        queryArray.push({
          id: "endDate",
          value: selectedEndDate!.format("DD-MM-YYYY"),
        });
      }

      const newParams = queryArray.reduce(
        (acum, currentValue, currentIndex) => {
          acum += `${currentIndex === 0 ? "?" : "&"}${currentValue.id}=${
            currentValue.value
          }`;
          return acum;
        },
        ""
      );
      history.push(newParams);
      await fetchHotelDataList({
        iniDate: selectedIniDate?.format("DD-MM-YYYY"),
        endDate: selectedEndDate?.format("DD-MM-YYYY"),
      });
    } catch (error) {
      console.log(error);
      captureError(error, {
        description: "error from handleAvailabilitySearch in PropertyCard.tsx",
      });
      updateUrlParams({
        updatePage: APP_PAGES.ERROR_PAGE,
      });
    }
  };

  const handleCheckAvailability = async () => {
    setGetAvailabilityLoading(true);
    const response = await apiGetCalendarPrice({
      serverPath,
      data: {
        iniDate: moment(iniDate, "DD-MM-YYYY")
          .subtract(2, "month")
          .format("DD-MM-YYYY"),
        endDate: moment(endDate, "DD-MM-YYYY")
          .add(3, "months")
          .format("DD-MM-YYYY"),
        hotelId: data.id,
        adults,
      },
    });
    if (response.status === 200) {
      const resData = response.data;
      let availableDates: { [date: string]: boolean } = {};
      let unavailableDates: { [date: string]: boolean } = {};
      resData.priceCalendarInfoByRoomTypeList[0].priceCalendarInfoList.map(
        (date) => {
          if (date.available) {
            return (availableDates[date.date] = true);
          }
          return (unavailableDates[date.date] = true);
        }
      );
      setDatesAvailable(availableDates);
      setDatesUnavailable(unavailableDates);
      setCheckAvailabilityIniDate(resData.iniDate);
      setCheckAvailabilityEndDate(resData.endDate);
    }

    setGetAvailabilityLoading(false);
  };

  useEffect(() => {
    if (
      hotelDescriptionEl.current?.offsetHeight &&
      hotelDescriptionEl.current?.offsetHeight > 150
    ) {
      setIsTextOverflowing(true);
    } else {
      setIsTextOverflowing(false);
    }
  }, []);

  const isOffer =
    filterState.isFreeCancelable === FilterSortType.UNSET
      ? (getMinPrice([data.priceRefundable, data.priceNotRefundable]) ===
          data.priceRefundable &&
          data.priceRefundable &&
          data.priceNoOfferRefundable &&
          !(data.priceRefundable === data.priceNoOfferRefundable)) ||
        (getMinPrice([data.priceRefundable, data.priceNotRefundable]) ===
          data.priceNotRefundable &&
          data.priceNotRefundable &&
          data.priceNoOfferNotRefundable &&
          !(data.priceNotRefundable === data.priceNoOfferNotRefundable))
      : filterState.isFreeCancelable
      ? data.priceRefundable &&
        data.priceNoOfferRefundable &&
        !(data.priceRefundable === data.priceNoOfferRefundable)
      : data.priceNotRefundable &&
        data.priceNoOfferNotRefundable &&
        !(data.priceNotRefundable === data.priceNoOfferNotRefundable);

  const linkToProperty = `${document.location.pathname}?${
    environmentId ? `environment=${environmentId}` : ""
  }&iniDate=${iniDate}&endDate=${endDate}&approute=property/${data.id}${
    childrenAges ? `&childrenAges=${childrenAges}` : ""
  }${adults ? `&adults=${adults}` : ""}${
    language ? `&language=${language}` : ""
  }&tourist=${tourist}`;

  return (
    <div className={styles.mainContainer}>
      <div
        className={`${styles.propertyCard} ${isColumn && styles.mapview}`}
        onMouseEnter={() =>
          setActiveHotel &&
          setActiveHotel({
            id: data.id,
            name: data.name,
            reviews: data.opinionReview,
            imagePath: data.imagePathList[0],
            unitsFree: data.unitsFree,
            nights: data.nights,
            price: `${currency}
          ${
            filterState.isFreeCancelable === FilterSortType.UNSET
              ? getMinPrice([data.priceRefundable, data.priceNotRefundable])
              : filterState.isFreeCancelable
              ? data.priceRefundable
              : data.priceNotRefundable
          }`,
            lat: data.latitude,
            lng: data.longitude,
          })
        }
        onMouseLeave={() => {
          setActiveHotel &&
            setActiveHotel({
              id: "",
              name: "",
              reviews: "",
              imagePath: "",
              unitsFree: "",
              nights: "",
              price: "",
              lat: "",
              lng: "",
            });
          setIsMiniCardOpen && setIsMiniCardOpen(false);
        }}
      >
        <div
          className={`${styles.propertyCard_container} ${
            isColumn && styles.mapview
          }`}
        >
          <div className={styles.propertyCard_swiperContainer}>
            <Swiper
              style={{ width: "100%", height: "100%" }}
              navigation={true}
              slidesPerView={1}
              pagination={{
                dynamicBullets: true,
              }}
              init={false}
            >
              {data.imagePathList.length !== 0 ? (
                data.imagePathList.map((url, index: number) => {
                  if (url) {
                    return (
                      <SwiperSlide key={`${url}-${index}`}>
                        <Link to={linkToProperty} className={styles.imageLink}>
                          <ImageWrapper url={url} alt="" />
                        </Link>
                      </SwiperSlide>
                    );
                  }
                  return null;
                })
              ) : (
                <SwiperSlide className={styles.imageContainer}>
                  <Link to={linkToProperty} className={styles.imageLink}>
                    <img
                      src="https://booking.availroom.com/v2/assets/images/noImage.jpeg"
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  </Link>
                </SwiperSlide>
              )}
            </Swiper>

            {showLastRoomMessageInfo &&
              (isOffer || +data.unitsFree === 1 || +data.unitsFree === 2) && (
                <div
                  className={`propertyCard__propertyAvailabilityLabel ${
                    styles.availableLabel
                  } ${
                    isOffer
                      ? styles.availableLabelRed
                      : styles.availableLabelYellow
                  }`}
                >
                  {/* <img
                    src={
                      isOffer
                        ? "https://booking.availroom.com/v2/assets/icons/availableRedLabel.svg"
                        : "https://booking.availroom.com/v2/assets/icons/availableYellowLabel.svg"
                    }
                    alt=""
                  /> */}
                  <span>
                    {isOffer
                      ? `${t("property.offerAvailable")}`
                      : `${t("property.just")} ${data.unitsFree}
                  ${t("property.available")}!`}
                  </span>
                </div>
              )}
          </div>

          <div
            className={`${styles.propertyCard_description} ${
              isColumn && styles.mapview
            }`}
          >
            <div className={styles.propertyCard_description_container}>
              <div className={styles.propertyCard_description_topbar}>
                <div className={styles.propertyCard_description_topbar_title}>
                  <Link
                    to={linkToProperty}
                    className={`${styles.title} propertyCard__title`}
                  >
                    {data.name}
                  </Link>
                  {!hideRating && (
                    <TitleStars opinionReview={data.opinionReview} />
                  )}
                </div>
                <div className={styles.propertyCard_description_topbar_info}>
                  <div>{data.hotelType}</div>
                  <div className={`${styles.address} ${styles.iconLabel}`}>
                    <img
                      src="https://booking.availroom.com/v2/assets/icons/place.svg"
                      alt=""
                    />
                    {data.address}
                  </div>
                  <div className={`${styles.occupancy} ${styles.iconLabel}`}>
                    <img
                      src="https://booking.availroom.com/v2/assets/icons/user.svg"
                      alt="icon"
                    />
                    x{data.maxCapacity}
                  </div>
                  <div className={styles.divider}></div>
                </div>
              </div>
              <div
                className={styles.propertyCard_description_info}
                ref={hotelDescriptionContainer}
              >
                <div className={styles.descriptionContainer}>
                  <div
                    ref={hotelDescriptionEl}
                    className={`${
                      isTextOverflowing && !showOverflowText
                        ? styles.overflow
                        : ""
                    }`}
                  >
                    {data.hotelDescription &&
                      parse(data.hotelDescription.replace("&nbsp;", ""))}
                  </div>
                </div>
                {isTextOverflowing && (
                  <div
                    onClick={() => {
                      setShowOverflowText(!showOverflowText);
                    }}
                    className={`${styles.seeMoreBtn} ${
                      showOverflowText && styles.seeMoreBtn_opened
                    }`}
                  >
                    <CustomButton
                      className={`${styles.showOverflowTextButton} seeMoreBtn`}
                    >
                      {!showOverflowText
                        ? t("labels.seeMore")
                        : t("labels.seeLess")}
                    </CustomButton>
                  </div>
                )}
              </div>
            </div>
            <div
              className={`${styles.propertyCard_bookContainer} ${
                isColumn ? styles.mapview : ""
              }`}
            >
              <BookingPrice
                nights={data.nights}
                allowAllGuestPrice={props.allowAllGuest}
                isOffer={isOffer}
                filterState={filterState}
                data={data}
                iniDate={iniDate}
                endDate={endDate}
                isColumn={isColumn}
                onCheckAvailability={handleCheckAvailability}
                onOpenAvailabilityPicker={setShowHotelAvailabilityPicker}
                showHotelAvailabilityPicker={showHotelAvailabilityPicker}
                linkToProperty={linkToProperty}
              />
            </div>
          </div>
        </div>
        <div className={styles.propertyCard_checkAvailability}>
          {showHotelAvailabilityPicker &&
            (!getAvailabilityLoading ? (
              <div className={styles.checkAvailabilityCalendarWrapper}>
                <div className={styles.customDateRangePickerWrapper}>
                  <CustomDateRangePicker
                    {...(isColumn && { orientation: "vertical" })}
                    noInput
                    availableDates={datesAvailable}
                    unavailableDates={datesUnavailable}
                    className={styles.notAvailableDatePicker}
                    minDate={moment(checkAvailabilityIniDate, "DD-MM-YYYY")}
                    maxDate={moment(checkAvailabilityEndDate, "DD-MM-YYYY")}
                    startDate={selectedIniDate}
                    endDate={selectedEndDate}
                    onDateChange={(dates) => {
                      // if (
                      //   datesUnavailable &&
                      //   dates.startDate &&
                      //   dates.endDate
                      // ) {
                      //   if (
                      //     Object.keys(datesUnavailable).some((date) =>
                      //       moment(date, "DD-MM-YYYY").isBetween(
                      //         dates.startDate,
                      //         dates.endDate
                      //       )
                      //     )
                      //   ) {
                      //     setDatePickerError(t("errors.notUnavailableDates"));
                      //     setSelectedEndDate(dates.endDate);
                      //     setFocusedInput("startDate");
                      //     setTimeout(() => {
                      //       setSelectedIniDate(null);
                      //       setSelectedEndDate(null);
                      //     }, 0);
                      //     return;
                      //   }
                      // }
                      // setDatePickerError("");
                      setSelectedIniDate(dates.startDate);
                      setSelectedEndDate(dates.endDate);
                    }}
                    initialMonth={
                      selectedIniDate || moment(iniDate, "DD-MM-YYYY")
                    }
                    focusedInput={focusedInput ?? "startDate"}
                    onFocusChange={(focusedInput) => {
                      setFocusedInput(focusedInput);
                    }}
                  />
                </div>
                {datePickerError && (
                  <ErrorString>{datePickerError}</ErrorString>
                )}
                <div
                  onClick={handleAvailabilitySearch}
                  className={styles.checkAvailabilityCalendarButton}
                >
                  <CustomButton />
                </div>
              </div>
            ) : (
              <div className={styles.notAvailableDatePicker}>
                <CustomSpinner />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
